import { Link, useLocation } from "react-router-dom";
import { TrendingUp, Landmark, ClipboardList } from "lucide-react";
import {
  useWorkProgressLinks,
  type WorkProgressLink,
} from "@/features/tasks/hooks/useWorkProgressLinks";

/* Sekcja „Postęp prac" w widoku Friday (tablica + lista). Zbiera widoki, które
   wcześniej były osobnymi pozycjami menu. W sidebarze ich liczniki są zsumowane
   w jeden badge przy Friday — tutaj, po wejściu, każdy odnośnik ma własny. */

const ICONS: Record<string, React.ReactNode> = {
  "/tasks/progress": <TrendingUp size={15} />,
  "/finances/self-allocation": <Landmark size={15} />,
  "/finances/self-allocations-admin": <ClipboardList size={15} />,
};

function Badge({ link }: { link: WorkProgressLink }) {
  if (link.count <= 0) return null;
  const cls =
    link.tone === "red"
      ? "bg-[var(--color-primary)] text-[var(--color-text-inverse)]"
      : "bg-amber-500 text-white";
  return (
    <span
      className={`text-[10px] font-mono rounded-full px-1.5 py-0.5 leading-none ${cls}`}
    >
      {link.count}
    </span>
  );
}

export function WorkProgressSection() {
  const links = useWorkProgressLinks();
  // Skąd wyszliśmy (tablica czy lista) — BackToFridayLink w docelowym widoku
  // odczytuje to z `?from=` i wraca dokładnie tutaj.
  const { pathname } = useLocation();
  if (links.length === 0) return null;

  return (
    <section className="flex flex-wrap items-center gap-2 flex-shrink-0 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/40 px-3 py-2">
      <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
        Postęp prac
      </span>
      {links.map((link) => (
        <Link
          key={link.to}
          to={`${link.to}?from=${encodeURIComponent(pathname)}`}
          title={link.title}
          className="flex items-center gap-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50"
        >
          {ICONS[link.to]}
          <span>{link.label}</span>
          <Badge link={link} />
        </Link>
      ))}
    </section>
  );
}
